import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getHeaders = () => {
  const token = localStorage.getItem("edugrade_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const api = {
  get: (url, config = {}) =>
    axios.get(`${API_BASE}${url}`, { ...config, headers: { ...getHeaders(), ...config.headers } }),
  post: (url, data, config = {}) =>
    axios.post(`${API_BASE}${url}`, data, { ...config, headers: { ...getHeaders(), ...config.headers } }),
  put: (url, data, config = {}) =>
    axios.put(`${API_BASE}${url}`, data, { ...config, headers: { ...getHeaders(), ...config.headers } }),
  delete: (url, config = {}) =>
    axios.delete(`${API_BASE}${url}`, { ...config, headers: { ...getHeaders(), ...config.headers } }),
  upload: (url, file, onProgress) => {
    const formData = new FormData();
    formData.append("file", file);
    return axios.post(`${API_BASE}${url}`, formData, {
      headers: { ...getHeaders(), "Content-Type": "multipart/form-data" },
      onUploadProgress: onProgress,
    });
  },
  getFile: (path) =>
    axios.get(`${API_BASE}/files/${path}`, {
      headers: getHeaders(),
      responseType: "blob",
    }),
};
